import React from "react";
import "@/App.css";
import "./styles/custom.css";
import "./styles/pages.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/sonner";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Results from "./pages/Results";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import StrengthConditioning from "./pages/services/StrengthConditioning";
import WeightLoss from "./pages/services/WeightLoss";
import BodybuildingPrep from "./pages/services/BodybuildingPrep";
import MarathonTraining from "./pages/services/MarathonTraining";
import LifestyleCoaching from "./pages/services/LifestyleCoaching";
import MuscleGain from "./pages/services/MuscleGain";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/strength-conditioning" element={<StrengthConditioning />} />
            <Route path="/services/weight-loss" element={<WeightLoss />} />
            <Route path="/services/bodybuilding-prep" element={<BodybuildingPrep />} />
            <Route path="/services/marathon-training" element={<MarathonTraining />} />
            <Route path="/services/lifestyle-coaching" element={<LifestyleCoaching />} />
            <Route path="/services/muscle-gain" element={<MuscleGain />} />
            <Route path="/results" element={<Results />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
